import { render, staticRenderFns } from "./ProductManagementHome.vue?vue&type=template&id=3a6a4498&"
import script from "./ProductManagementHome.vue?vue&type=script&lang=js&"
export * from "./ProductManagementHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports